module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Ge-Ha-Ia.2e8a5fb0.png";